module.exports = __webpack_public_path__ + "img/img0301.4b118201.png";